/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevRobotIcon16Solid = forwardRef('DevRobotIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.75 2.528A1.374 1.374 0 0 0 8 0a1.375 1.375 0 0 0-.75 2.528V3h-2A3.25 3.25 0 0 0 2 6.25V7H1a1 1 0 0 0 0 2h1v2.75A3.25 3.25 0 0 0 5.25 15h5.5A3.25 3.25 0 0 0 14 11.75V9h1a1 1 0 1 0 0-2h-1v-.75A3.25 3.25 0 0 0 10.75 3h-2v-.472Zm3 5.472a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM5.5 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
